import './sidebar.css'
import { Typography, Toolbar } from '@material-ui/core'
import DrawerComponent from './Drawer'
import { LineStyle, PowerSettingsNewOutlined } from '@material-ui/icons'
import { Link, NavLink } from 'react-router-dom'
export default function Sidebar() {
  //const { dispatch } = useContext(AuthContext)
  const logoutFc = () => {
    localStorage.clear()
    window.location.reload()
  }

  return (
    <div className='mainMenu'>
      <div className='wrapLogo'>
        <div className='userLogo'>
          <Link to={`${process.env.PUBLIC_URL}/`}>
            <Typography
              className='logoMain'
              variant='h1'
              style={{ fontWeight: '500', fontSize: '30px' }}
            >
              NATIONAL LASER
            </Typography>
            <Typography
              className='logoSub'
              variant='h2'
              style={{ fontWeight: '100', fontSize: '20px' }}
            >
              INSTITUTE
            </Typography>
            <Typography
              className='slogan'
              variant='h6'
              style={{
                fontWeight: '100',
                fontSize: '15px',
                fontStyle: 'italic'
              }}
            >
              20 Years of Excellence!
            </Typography>
          </Link>
        </div>
      </div>
      <div className='sidebarWrapper'>
        <div className='sidebarMenu'>
          <ul className='sidebarList'>
            <li className='sidebarListItem'>
              <NavLink
                to={`${process.env.PUBLIC_URL}/dashboard`}
                activeClassName='active'
              >
                <LineStyle className='sidebarIcon' />
                Manage Affiliates
              </NavLink>
            </li>
          </ul>
        </div>
        <div className='sidebarMenu'>
          <ul className='sidebarList'>
            {/* <Link to={`${process.env.PUBLIC_URL}/dashboard`} className='link'>
              <li className='sidebarListItem'>Manage Affiliates</li>
            </Link> */}
            <li className='sidebarListItem'>
              <NavLink
                to={`${process.env.PUBLIC_URL}/upload-data`}
                activeClassName='active'
              >
                Upload Data
              </NavLink>
            </li>
            <li className='sidebarListItem'>
              <NavLink
                to={`${process.env.PUBLIC_URL}/marketing-resources`}
                activeClassName='active'
              >
                Marketing Resources
              </NavLink>
            </li>
          </ul>
        </div>

        <div className='sidebarMenu'>
          <ul className='sidebarList'>
            <li className='sidebarListItem' onClick={logoutFc}>
              <PowerSettingsNewOutlined className='sidebarIcon' />
              Logout
            </li>
          </ul>
        </div>
      </div>
      <Toolbar className='toolbar'>
        <DrawerComponent />
      </Toolbar>
    </div>
  )
}
